import React from 'react';
import { Route, Navigate } from 'react-router-dom';

interface CatchAllRouteProps {
  isAuthenticated: boolean;
}

const CatchAllRoute: React.FC<CatchAllRouteProps> = ({ isAuthenticated }) => {
  return (
    <Route
      path="*"
      element={<Navigate to={isAuthenticated ? '/' : '/login'} replace />}
    />
  );
};

export default CatchAllRoute;
